import { FC, useState } from "react";
import styles from "./styles.module.css";

import ResultList from "./ResultList";
import StatusFilter from "./StatusFilter";
import TagFilter from "./TagFilter";

const MainSection: FC = () => {
  const [view, setView] = useState<"grid" | "list">("grid");

  return (
    <div className={styles.root} id="list-hkt">
      <TagFilter />
      <StatusFilter view={view} setView={setView} />
      <ResultList view={view} />
    </div>
  );
};

export default MainSection;
